<template>
	<div>
		<model-autocomplete
			ref="modelAutocomplete"
			v-model="selectedItems"
			v-bind="$attrs"
			v-on="$listeners"
			:model="model"
			:optionName="optionName"
			return-object
		>
			<template v-slot:prepend-item>
				<v-list-item ripple @mousedown.prevent @click="newItem">
					<v-list-item-action>
						<v-icon color="indigo darken-4"> mdi-plus </v-icon>
					</v-list-item-action>
					<v-list-item-content>
						<v-list-item-title>
							{{ $t('new') }}
						</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
				<v-divider class="mt-2"></v-divider>
			</template>
		</model-autocomplete>
		<!-- <slot name="default" v-bind="{ value: editorItem, setValue: emitEditorItem, disabled }" /> -->
		<slot-dialog
			v-model="dialogOpen"
			:title="$tc('$global.models.' + model.toString())"
			:dialogWidth="700"
			@close="closeDialog"
			v-if="dialogOpen"
		>
			<crud-editor v-model="editorItem" :optionName="optionName" @save="refresh" @cancel="closeDialog">
				<!-- Forward all named slots -->
				<slot v-for="slot of Object.keys($slots)" :name="slot" :slot="slot" />
				<!-- Forward all scoped slots -->
				<template v-for="slot of Object.keys($scopedSlots)" :slot="slot" slot-scope="scope">
					<slot :name="slot" v-bind="scope" />
				</template>
			</crud-editor>
		</slot-dialog>
	</div>
</template>
<script>
import i18n from './dictionary';
import SlotDialog from '@/components/base/slotDialog/SlotDialog.vue';
import ModelAutocomplete from '@/components/models/autocompletes/ModelAutocomplete.vue';
import CrudEditor from '@/components/crud/crudEditor/CrudEditor.vue';

export default {
	name: 'ModelAutocompleteAddNew',
	components: { ModelAutocomplete, SlotDialog, CrudEditor },
	i18n,
	props: {
		value: {
			required: true,
		},
		model: {
			type: Function,
			required: true,
		},
		optionName: {
			type: String,
			default: 'none',
		},
		constructorDefaults: {
			type: Object,
			default: () => ({}),
		},
	},
	data() {
		return {
			dialogOpen: false,
			editorItem: null,
			itemBackup: null,
		};
	},
	computed: {
		selectedItems: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit('input', value);
			},
		},
	},
	methods: {
		emitEditorItem(value) {
			this.$emit('input', value);
		},
		newItem() {
			this.dialogOpen = true;
			this.editorItem = this.model.create(this.constructorDefaults);
		},
		closeDialog() {
			this.dialogOpen = false;
		},
		refresh(value) {
			this.$refs.modelAutocomplete
				.refresh()
				.then(() => {
					if (Array.isArray(this.selectedItems)) this.$emit('input', [...this.selectedItems, value]);
					else this.$emit('input', value);
				})
				.finally(() => {
					this.closeDialog();
				});
		},
	},
};
</script>
